import script from "./exitTeamDialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./exitTeamDialog.vue?vue&type=script&lang=tsx&setup=true"

import "./exitTeamDialog.vue?vue&type=style&index=0&id=bdcf4b18&lang=less"

const __exports__ = script;

export default __exports__